function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

const SvgOrder = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#388E3C"
    },
    d: "M 29 38 L 7 38 C 5.894531 38 5 37.105469 5 36 L 5 15 C 5 13.894531 5.894531 13 7 13 L 27 13 C 28.105469 13 29 13.894531 29 15 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8BC34A"
    },
    d: "M 43 38 L 29 38 L 29 18 L 39.558594 18 C 40.417969 18 41.183594 18.550781 41.457031 19.367188 L 45 30 L 45 36 C 45 37.105469 44.105469 38 43 38 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M 41 37.5 C 41 39.984375 38.984375 42 36.5 42 C 34.015625 42 32 39.984375 32 37.5 C 32 35.015625 34.015625 33 36.5 33 C 38.984375 33 41 35.015625 41 37.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M 19 37.5 C 19 39.984375 16.984375 42 14.5 42 C 12.015625 42 10 39.984375 10 37.5 C 10 35.015625 12.015625 33 14.5 33 C 16.984375 33 19 35.015625 19 37.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78909C"
    },
    d: "M 38 37.5 C 38 38.328125 37.328125 39 36.5 39 C 35.671875 39 35 38.328125 35 37.5 C 35 36.671875 35.671875 36 36.5 36 C 37.328125 36 38 36.671875 38 37.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78909C"
    },
    d: "M 16 37.5 C 16 38.328125 15.328125 39 14.5 39 C 13.671875 39 13 38.328125 13 37.5 C 13 36.671875 13.671875 36 14.5 36 C 15.328125 36 16 36.671875 16 37.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M 40 28 L 33 28 C 32.449219 28 32 27.550781 32 27 L 32 21 C 32 20.449219 32.449219 20 33 20 L 38.277344 20 C 38.710938 20 39.09375 20.273438 39.226563 20.683594 L 40.949219 25.847656 C 40.980469 25.949219 41 26.054688 41 26.160156 L 41 27 C 41 27.550781 40.550781 28 40 28 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B5E20"
    },
    d: "M 12.5 27 C 18.851563 27 24 21.851563 24 15.5 C 24 14.640625 23.898438 13.804688 23.71875 13 L 7 13 C 5.894531 13 5 13.894531 5 15 L 5 24.207031 C 7.015625 25.941406 9.632813 27 12.5 27 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00ACC1"
    },
    d: "M 22 15.5 C 22 20.746094 17.746094 25 12.5 25 C 7.253906 25 3 20.746094 3 15.5 C 3 10.253906 7.253906 6 12.5 6 C 17.746094 6 22 10.253906 22 15.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEEEEE"
    },
    d: "M 12.5 8.5 C 8.632813 8.5 5.5 11.632813 5.5 15.5 C 5.5 19.367188 8.632813 22.5 12.5 22.5 C 16.367188 22.5 19.5 19.367188 19.5 15.5 C 19.5 11.632813 16.367188 8.5 12.5 8.5 Z M 12.5 16 C 12.226563 16 12 15.777344 12 15.5 C 12 15.222656 12.226563 15 12.5 15 C 12.773438 15 13 15.222656 13 15.5 C 13 15.777344 12.773438 16 12.5 16 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M 12 10 L 13 10 L 13 14.5625 L 12 14.5625 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M 16.34375 18.171875 L 15.167969 19.34375 L 12.398438 16.570313 L 13.570313 15.398438 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M 12.5 14 C 11.671875 14 11 14.671875 11 15.5 C 11 16.328125 11.671875 17 12.5 17 C 13.328125 17 14 16.328125 14 15.5 C 14 14.671875 13.328125 14 12.5 14 Z M 12.5 16 C 12.226563 16 12 15.777344 12 15.5 C 12 15.222656 12.226563 15 12.5 15 C 12.773438 15 13 15.222656 13 15.5 C 13 15.777344 12.773438 16 12.5 16 Z "
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOrder, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/order.97dabbdd.svg";
export { ForwardRef as ReactComponent };